<template>
  <div id="project__deliverable__calendar__component">
    <HeaderControlsProjectDeliverableCalendar :projectDeliverable="true" :myWeek='false' :namespace="namespace"/>
    <FullCalendar ref="csm__project__calendar" :options="{...calendarOptions}">
      <template v-slot:eventContent='arg'>
        <div :id="'eventNo' + arg.event.id">
          <span v-html="arg.event.extendedProps.deliverable + ' > ' + arg.event.title"
            v-if="(typeof arg.event.extendedProps.deliverable != 'undefined')" @click="handleEventTitleClick(arg)"></span>
          <span v-else v-html="arg.event.title" @click="handleEventTitleClick(arg)"></span>
        </div>
        <b-tooltip custom-class="calendar-due-date-tooltip" :delay="0" :ref="`eventTooltip${arg.event.id}`"
          triggers="manual" :target="'eventNo' + arg.event.id"
          :show="calendarDueDateTooltip[`eventTooltip${arg.event.id}`]">
          Due date: {{ formatDueDateTooltip(arg.event.extendedProps.dueDate) }}
        </b-tooltip>
      </template>
      <template v-slot:dayCellContent='arg'>
        <a id="fc-dom-4" class="fc-daygrid-day-number"
          :aria-label="$moment(arg.date).format('MMMM DD, YYYY')">{{arg.dayNumberText}}</a>
      </template>
    </FullCalendar>
  </div>
</template>

<script>
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import HeaderControlsProjectDeliverableCalendar from "../common/HeaderControlsProjectDeliverableCalendar"

export default {
  props: {
    namespace: String,
  },
  components: {
    FullCalendar, // make the <FullCalendar> tag available
      HeaderControlsProjectDeliverableCalendar,
  },
  computed: {
    ...mapGetters([
      'projectCalendarEvents', 
      'deliverableDetail',
      'projectCalendarFilter'
    ]),
    ...mapState({
      getDeliverableTemplateSlug(state, getters) {
        return getters['getDeliverableTemplateSlug']
      },
    }),
  },
  data() {
    return {
        calendarOptions: {
            events: this.getCalendarEvents,
            plugins: [
            dayGridPlugin,
            listPlugin,
            interactionPlugin // needed for dateClick
            ],
            customButtons: {
              collapseButton: {
                text: 'Collapse',
                click: () => {
                  this.handleHideClick(this.$refs.csm__project__calendar.getApi());
                }
              }
            },
            headerToolbar: {
            left: 'prev,next today',
            center: 'title',
              right: 'collapseButton dayGridDay,dayGridWeek,weekAgenda,dayGridMonth'
            },
          views: {
            weekAgenda: {
              type: 'listWeek',
              buttonText: 'Agenda'
            },
            week: {
              // options apply to dayGridWeek and timeGridWeek views
              dayMaxEvents: false, // Show all events 
            },
            day: {
              // options apply to dayGridDay and timeGridDay views
              dayMaxEvents: false, // Show all events 
            }
          },
            initialView: 'dayGridWeek',
            eventDisplay:'block',
            editable: false,
            selectable: false,
            selectMirror: true,
            dayMaxEvents: true,
            weekends: true,
            select: this.handleDateSelect,
            eventClick: this.handleEventTitleClick,
            datesSet: this.handleDateOrViewChange,
            eventMouseEnter: this.handleEventMouseEnter,
            eventMouseLeave: this.handleEventMouseLeave,
            eventClassNames: 'mb-2',
            moreLinkClick: this.handleMoreLinkClick,
            /* you can update a remote database when these fire:
            eventAdd:
            eventChange:
            eventRemove:
            */
        },
        expandDate: null,
        calendarDueDateTooltip: {},
        calendarDueDateTooltipStay: false,
    }
  },
  mounted() {
    $(".fc-collapseButton-button").attr("disabled", true);
    this.$root.$on('calendarHeaderFilterUpdated', this.onCalendarHeaderFilterUpdated);
    this.$root.$on('re__fetch__calendar__data', this.onSingleEventUpdated);
  },
  methods: {
    ...mapActions({
      getDeliverableCalendarData(dispatch, payload) {
        return dispatch(this.namespace + 'getDeliverableCalendarData', payload)
      },
    }),
    ...mapMutations({
      setDataLoading(commit, payload) {
        return commit('setDataLoading', payload)
      },
    }),
    handleDateOrViewChange(dateInfo ){
      const clonedFilterQuery = _.cloneDeep(this.projectCalendarFilter);
      clonedFilterQuery.calendarViewType = dateInfo.view.type;
      this.$store.commit(this.namespace + "setProjectCalendarFilter", clonedFilterQuery);
    },
    async getCalendarEvents(info, successCallback, failureCallback) {
      if (this.projectCalendarFilter) {
        const clonedFilterQuery = _.cloneDeep(this.projectCalendarFilter);
        clonedFilterQuery.listByDate = true;
        clonedFilterQuery.isCalendarUpdate = true;
        clonedFilterQuery.listByDateRange = {
          startDate: info.start,
          endDate: info.end,
        };
        if (clonedFilterQuery.dataSetType == "") {
          clonedFilterQuery.dataSetType = "deliverables";
        }
        const hasChanged = !_.isEqual(this.projectCalendarFilter, clonedFilterQuery);
        if (hasChanged) {
          // Commit only if there is a change
          this.$store.commit(this.namespace + "setProjectCalendarFilter", clonedFilterQuery);
        }
        let eventsToShow = [];
        this.setDataLoading(true);
        eventsToShow = await this.$store.dispatch(this.namespace + "fetchProjectCalendarDeliverable").then((resp) => {
          this.setDataLoading(false);
          return resp;
        });
        successCallback(eventsToShow);
      }
    },
    createEventId() {
      let eventGuid = 0
      return String(eventGuid++)
    },

    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: this.createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },

    handleEventClick(clickInfo) {
      let existingEvents = clickInfo.view.calendar.getEvents();
      existingEvents.forEach(x => {
        x.setProp("classNames", []);
      });
      clickInfo.event.setProp("classNames", ['selected']);
    },

    handleEventTitleClick(clickInfo) {
      this.setDataLoading(true);
      let deliverableId = clickInfo.event.groupId != '' ? clickInfo.event.groupId : clickInfo.event.id
        this.$store
            .dispatch("getDeliverableDetail", { deliverableId })
            .then(() => {
                let currentTitle = document.title.match(/\(\d+\)\s/g);
                if(!currentTitle) {
                    document.title = this.deliverableDetail.title;
                } else {
                    document.title = currentTitle[0] + this.deliverableDetail.title;
                }
                let modalId = "editDeliverableModal";
                let template_slug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
                if (template_slug == "social-media") {
                  modalId = "editSocialModal";
                } else if (template_slug == "organic-social-media-plan") {
                  modalId = "editOrganicSocialMediaPlanModal";
                }
                this.$bvModal.show(modalId);
                this.setDataLoading(false);
            });
    },

    handleEventMouseEnter(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = true;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      classArray.push('hover');
      mouseInfo.event.setProp("classNames", classArray);
    },
    handleEventMouseLeave(mouseInfo) {
      if (!this.calendarDueDateTooltipStay) this.calendarDueDateTooltip[`eventTooltip${mouseInfo.event.id}`] = false;
      const classArray = Object.assign([], mouseInfo.event.classNames || []);
      const newClassArray = classArray.filter(x => x != 'hover');
      mouseInfo.event.setProp("classNames", newClassArray);
    },

    handleMoreLinkClick(clickInfo) {
      if (this.calendarOptions.dayMaxEvents === true) {
        this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      } else {
        this.calendarOptions.dayMaxEvents += clickInfo.hiddenSegs.length;
      }
      this.renderCount = 2;
      return clickInfo.view.type;
    },

    handleMoreLinkClick(clickInfo) {
      this.expandDate = clickInfo.date;
      this.calendarOptions.dayMaxEvents = clickInfo.allSegs.length;
      $(".fc-collapseButton-button").attr("disabled", false);
      return clickInfo.view.type;
    },

    handleHideClick(info) {
      this.calendarOptions.dayMaxEvents = true;
      this.expandDate = null;
      $(".fc-collapseButton-button").attr("disabled", true);
    },
    formatDueDateTooltip(date) {
      if (date) {
        const dateMoment = this.$moment(date);
        return dateMoment.format("MMMM DD, YYYY");
      } else {
        return 'No due date';
      }
    },
    onCalendarHeaderFilterUpdated() {
      if (typeof this.$refs.csm__project__calendar != "undefined") {
        const calendarApi = this.$refs.csm__project__calendar.getApi();
        // Force FullCalendar to re-render
        calendarApi.refetchEvents();
      }
    },
    async onSingleEventUpdated(eventData) {
      if (typeof this.$refs.csm__project__calendar != "undefined" && eventData) {
        const calendarApi = this.$refs.csm__project__calendar.getApi();
        if (eventData.id) {
          let eventInfo = {};
          this.setDataLoading(true);
          let template_slug = this.getDeliverableTemplateSlug(parseInt(eventData.deliverable_template_id));
          if (template_slug == "social-media" && eventData.in_social_series) {
            // refetch entire calendar when closing multi day sm post
            calendarApi.refetchEvents();
          } else {
            eventInfo = await this.getDeliverableCalendarData(eventData.id).then((resp) => {
              this.setDataLoading(false);
              return resp;
            });
            if (Object.entries(eventInfo).length) {
              const eventToUpdate = calendarApi.getEventById(eventData.id);
              if (eventToUpdate) {
                // Force updated event to re-render with latest details
                eventToUpdate.setProp("title", eventInfo.title);
                eventToUpdate.setProp("backgroundColor", eventInfo.backgroundColor);
                eventToUpdate.setExtendedProp("dueDate", eventInfo.extendedProps.dueDate);
                eventToUpdate.setDates(eventInfo.start, eventInfo.end);
              } else {
                // newly created social media post from osmp modal
                calendarApi.addEvent(eventInfo);
              }
            }
          }
        }
      }
    },
  }
}
</script>

<style>

</style>